export default __webpack_public_path__ + "static/media/chair.f9bf62b3.png";